import type { PlanSlug, PlanTier } from './subscription-status.enum';

export const UNLIMITED = -1 as const;

export interface PlanCatalog {
  slug: PlanSlug;
  tier: PlanTier;
  name: string;
  tierOrder: number;
  monthlyPriceCents: number;
  annualPriceCents: number;
  annualDiscountPercent: number;
  limits: {
    maxAdmins: number;
    maxWorkflows: number;
    maxAutomations: number;
    maxWhatsAppPerMonth: number;
    maxForms: number;
    maxProjects: number;
  };
  features: {
    aiParser: boolean;
  };
  recommended: boolean;
}
